import React from 'react';

const ShippingPriceModal = ({ isOpen, onClose, company }) => {
  if (!isOpen || !company) return null;

  const prices = company.shipping_company_prices || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {company.logo_url ? (
                <img 
                  src={company.logo_url} 
                  alt={company.name}
                  className="w-12 h-12 rounded-lg object-contain bg-white p-2"
                />
              ) : (
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                  </svg>
                </div>
              )}
              <div>
                <h2 className="text-2xl font-bold">{company.name}</h2>
                <p className="text-blue-100">Detaylı Fiyat Tablosu</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-200"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* Modal Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
          {prices.length > 0 ? (
            <div className="space-y-6">
              {/* Özet Bilgiler */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-blue-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-blue-600">{prices.length}</div>
                  <div className="text-sm text-blue-700">Toplam Desi Seçeneği</div>
                </div>
                <div className="bg-green-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-green-600">
                    ₺{prices.length > 0 ? parseFloat(prices[0].city_price || 0).toFixed(2) : '0.00'}
                  </div>
                  <div className="text-sm text-green-700">En Düşük Şehir İçi (1 Desi)</div>
                </div>
                <div className="bg-purple-50 rounded-xl p-4 text-center">
                  <div className="text-2xl font-bold text-purple-600">
                    ₺{prices.length > 0 ? parseFloat(prices[0].intercity_price || 0).toFixed(2) : '0.00'}
                  </div>
                  <div className="text-sm text-purple-700">En Düşük Şehir Dışı (1 Desi)</div>
                </div>
              </div>

              {/* Detaylı Fiyat Tablosu */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">Desi Bazlı Fiyat Listesi</h3>
                
                {/* Masaüstü Tablo */}
                <div className="hidden md:block overflow-x-auto">
                  <table className="w-full">
                    <thead>
                      <tr className="border-b-2 border-gray-200">
                        <th className="text-left py-3 px-4 font-semibold text-gray-700">Desi</th>
                        <th className="text-center py-3 px-4 font-semibold text-blue-600">Şehir İçi</th>
                        <th className="text-center py-3 px-4 font-semibold text-purple-600">Şehir Dışı</th>
                      </tr>
                      <tr className="border-b border-gray-100 bg-gray-50">
                        <th className="text-left py-2 px-4 text-xs text-gray-500"></th>
                        <th className="text-center py-2 px-4">
                          <div className="grid grid-cols-3 gap-1 text-xs">
                            <span className="text-gray-600">Ham</span>
                            <span className="text-green-600">+KDV</span>
                            <span className="text-red-600">Nihai</span>
                          </div>
                        </th>
                        <th className="text-center py-2 px-4">
                          <div className="grid grid-cols-3 gap-1 text-xs">
                            <span className="text-gray-600">Ham</span>
                            <span className="text-green-600">+KDV</span>
                            <span className="text-red-600">Nihai</span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {prices.map((price, index) => {
                        const cityPrice = parseFloat(price.city_price || 0);
                        const intercityPrice = parseFloat(price.intercity_price || 0);
                        const cityPriceWithVat = parseFloat(price.city_price_with_vat || 0);
                        const intercityPriceWithVat = parseFloat(price.intercity_price_with_vat || 0);
                        const cityPriceFinal = parseFloat(price.city_price_final || 0);
                        const intercityPriceFinal = parseFloat(price.intercity_price_final || 0);
                        
                        return (
                          <tr key={price.desi} className={`border-b border-gray-100 hover:bg-white transition-colors ${index % 2 === 0 ? 'bg-gray-25' : 'bg-white'}`}>
                            <td className="py-3 px-4 font-medium text-gray-800">{price.desi} Desi</td>
                            <td className="py-3 px-4 text-center">
                              <div className="grid grid-cols-3 gap-1 text-xs">
                                <span className="text-gray-700 font-semibold">₺{cityPrice.toFixed(2)}</span>
                                <span className="text-green-700 font-semibold">₺{cityPriceWithVat.toFixed(2)}</span>
                                <span className="text-red-700 font-bold">₺{cityPriceFinal.toFixed(2)}</span>
                              </div>
                            </td>
                            <td className="py-3 px-4 text-center">
                              <div className="grid grid-cols-3 gap-1 text-xs">
                                <span className="text-gray-700 font-semibold">₺{intercityPrice.toFixed(2)}</span>
                                <span className="text-green-700 font-semibold">₺{intercityPriceWithVat.toFixed(2)}</span>
                                <span className="text-red-700 font-bold">₺{intercityPriceFinal.toFixed(2)}</span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                {/* Mobil Kartlar */}
                <div className="md:hidden space-y-3">
                  {prices.map((price, index) => {
                    const cityPrice = parseFloat(price.city_price || 0);
                    const intercityPrice = parseFloat(price.intercity_price || 0);
                    const cityPriceWithVat = parseFloat(price.city_price_with_vat || 0);
                    const intercityPriceWithVat = parseFloat(price.intercity_price_with_vat || 0);
                    const cityPriceFinal = parseFloat(price.city_price_final || 0);
                    const intercityPriceFinal = parseFloat(price.intercity_price_final || 0);
                    
                    return (
                      <div key={price.desi} className="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
                        <div className="text-center mb-4">
                          <span className="text-lg font-bold text-gray-800 bg-gray-100 px-3 py-1 rounded-full">{price.desi} Desi</span>
                        </div>
                        
                        <div className="grid grid-cols-2 gap-4">
                          {/* Şehir İçi */}
                          <div className="text-center">
                            <div className="text-sm font-semibold text-blue-600 mb-2">Şehir İçi</div>
                            <div className="space-y-1">
                              <div className="text-xs text-gray-600">Ham: <span className="font-semibold">₺{cityPrice.toFixed(2)}</span></div>
                              <div className="text-xs text-green-600">+KDV: <span className="font-semibold">₺{cityPriceWithVat.toFixed(2)}</span></div>
                              <div className="text-sm text-red-600 font-bold border-t pt-1">Nihai: ₺{cityPriceFinal.toFixed(2)}</div>
                            </div>
                          </div>
                          
                          {/* Şehir Dışı */}
                          <div className="text-center">
                            <div className="text-sm font-semibold text-purple-600 mb-2">Şehir Dışı</div>
                            <div className="space-y-1">
                              <div className="text-xs text-gray-600">Ham: <span className="font-semibold">₺{intercityPrice.toFixed(2)}</span></div>
                              <div className="text-xs text-green-600">+KDV: <span className="font-semibold">₺{intercityPriceWithVat.toFixed(2)}</span></div>
                              <div className="text-sm text-red-600 font-bold border-t pt-1">Nihai: ₺{intercityPriceFinal.toFixed(2)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Ek Bilgiler */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {company.delivery_time && (
                  <div className="bg-yellow-50 rounded-xl p-4">
                    <h4 className="font-semibold text-yellow-800 mb-2">Teslimat Süresi</h4>
                    <p className="text-yellow-700">{company.delivery_time}</p>
                  </div>
                )}
                
                <div className="bg-gray-50 rounded-xl p-4">
                  <h4 className="font-semibold text-gray-800 mb-2">Son Güncelleme</h4>
                  <p className="text-gray-600">
                    {new Date(company.last_updated).toLocaleDateString('tr-TR', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-12">
              <svg className="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Fiyat Bilgisi Bulunamadı</h3>
              <p className="text-gray-500">Bu kargo şirketi için henüz fiyat bilgisi yüklenmemiş.</p>
            </div>
          )}
        </div>

        {/* Modal Footer */}
        <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-500 text-white rounded-lg font-semibold hover:bg-gray-600 transition-all duration-200"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShippingPriceModal;